//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
    export default {
        data() {
            return {
               datalist:"",
               sun:"",
               discount:0,
               kfc:"",
               lock:1,
               docid:'',
               pay: true,
              inquirypeople:this.$store.state.inquirypeople,
              patientid: this.$store.state.userInfo.id,
              addressTitle:[],
              isNotBuy:'',//是否复诊
            }
        },
        // 生命周期之挂载完成
        methods: {
          getMyInquiry(){
            let params = {
              parameters: this.patientid
            };
            let _this=this;
            this.$doRequest("/api/inquiryPeople/getPatientInquiryPatient", params, res=>{
              _this.addressTitle=res.parameters;
              if(_this.addressTitle.length>0&&_this.inquirypeople.id==undefined){
                for(var i=0;i<_this.addressTitle.length;i++){
                  if(_this.addressTitle[i].isDefault==1){
                    _this.$store.state.inquirypeople=_this.addressTitle[i];
                    _this.$store.state.inquirypeople.id=_this.addressTitle[i].id;
                    _this.$store.state.inquirypeople.name=_this.addressTitle[i].name;
                  }else {
                    if (_this.addressTitle[i].relationCode == 'br') {
                      _this.$store.state.inquirypeople = _this.addressTitle[i];
                      _this.$store.state.inquirypeople.id=_this.addressTitle[i].id;
                      _this.$store.state.inquirypeople.name=_this.addressTitle[i].name;
                    }else{
                      _this.$store.state.inquirypeople = _this.addressTitle[0];
                      _this.$store.state.inquirypeople.id=_this.addressTitle[0].id;
                      _this.$store.state.inquirypeople.name=_this.addressTitle[0].name;
                    }
                  }
                }
              }
            })
            _this.gotoChat();
          },//获取就诊人
            query(){
              var _this=this;
              if(this.$store.state.userInfo.telephone == null || this.$store.state.userInfo.telephone == ''){
                  this.$toastMsg('请完善手机号');
                  this.$router.push({path: '/boundPhone'});
              }
              if(
                _this.$store.state.AllOfValue.ImDoctorInfo!=undefined
              ){
                _this.$doRequest(
                  "/api/PlacingOrder/underway?patientid="+_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId+"&doctorid="+_this.docid,null
//                "/api/PlacingOrder/underway?patientid="+_this.$store.state.userInfo.id+"&doctorid="+_this.docid,null
                  ,res => {
//                    if(res.parameters*1>0){
//                      common.unLock(_this,"todoctorLock"+_this.docid)
//                      _this.$router.push({path: '/physicianVisits?doctorID=' + _this.docid});
//                    }else{
                      _this.$doRequest(
                        "/api/AppHomePage/Index",{parameters:_this.docid}
                        ,res => {
                          _this.datalist = res;
                          if(res.isNoDisturb==2){
                            _this.$toastMsg("医生现在处于消息免到扰时段，时间段为"+res.noDisturb+"，医生会在上线后回复您");
                          };
                        });
//                    }
                  });
              }else{
                _this.$doRequest(
//                  "/api/PlacingOrder/underway?patientid="+_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId+"&doctorid="+_this.docid,null
                "/api/PlacingOrder/underway?patientid="+_this.$store.state.userInfo.id+"&doctorid="+_this.docid,null
                  ,res => {
//                    if(res.parameters*1>0){
//                      common.unLock(_this,"todoctorLock"+_this.docid)
//                      _this.$router.push({path: '/physicianVisits?doctorID=' + _this.docid});
//                    }else{
//                    会跳转到聊天界面
                      _this.$doRequest(
                        "/api/AppHomePage/Index",{parameters:_this.docid}
                        ,res => {
                          _this.datalist = res;
                          if(res.isNoDisturb==2){
                            _this.$toastMsg("医生现在处于消息免到扰时段，时间段为"+res.noDisturb+"，医生会在上线后回复您");
                          };
                        });
//                    }
                  });
              }


            },
            gotoshop(){
              if(
                this.$store.state.inquirypeople.id == ''||this.$store.state.inquirypeople.id == null
              ){
                this.$toastMsg('请选择就诊人');
                return;
              }
                if(this.lock == 0){
                    return
                }else{
                    this.lock = 0;
                    var _this = this
                    if(this.$store.state.userInfo.telephone == ""||this.$store.state.userInfo.telephone == null){
                        this.$router.push({path: '/boundPhone',query:{form: 'buyServiceDetails'}});
                    }else{
                      this.$doRequest(
                        "/api/PlacingOrder/DialecticalOpen", {
                          doctorid: this.docid,
                          patientid: this.$store.state.userInfo.id,
//                          patientid: this.$store.state.inquirypeople.id,
                          inquiryPeopleId:this.$store.state.inquirypeople.id,
//                          serviceid: 1,
                          serviceid: this.$store.state.isBuy == 0 ? 2 : 4,
                          paytype: 1,
                          kfc: this.kfcid
                        }
                        , res => {
                          try {
                            _this.$store.state.buyuser=_this.$store.state.inquirypeople.id;
//                            console.log(_this.$store.state.buyuser);

                            _this.datalist = res;
                            if (res.weiPayReturnEntiey.totalfee * 1 > 0) {
                              WeixinJSBridge.invoke('getBrandWCPayRequest', res.weiPayReturnEntiey.weiAppLetEntity, function (ress) {
                                _this.lock = 1;
                                // _this.$toastMsg(JSON.stringify(res),5000)
                                if (ress.err_msg == "get_brand_wcpay_request:ok") {
                                  _this.$doRequest("/api/Inquiry/orderDetails", {getOrder: 1, orderID: res.orderinfo.id,}, res => {
                                    var docid = _this.docid;
                                      common.unLock(_this, "todoctorLock" + _this.docid)
                                    _this.$store.state.inquirypeople='';
                                    _this.$router.push({path: '/physicianVisits?doctorID=' + docid});
                                  });
                                } else {
                                  _this.$doRequest("/api/orderinfo/cleanOrderForCode?orderId=" + res.orderinfo.id + "&type=1", null, res => {
                                  });
                                }
                              });
                            } else {
                              _this.lock = 1;
                              common.unLock(_this, "todoctorLock" + _this.docid)
                              _this.$router.push({path: '/physicianVisits?doctorID=' + _this.docid});
                            }
                          } catch (e) {
                            _this.lock = 1;
                          }
                        },
                        err => {
                          _this.lock = 1;
                          if (err.action == "1") {
                            common.unLock(_this, "todoctorLock" + _this.docid)
                            _this.$router.push({path: '/physicianVisits?doctorID=' + _this.docid});
                          }
                          _this.$toastMsg(err.message);
                        });
                    }
                }
            },
            gotokfc(){
                this.$store.state.sun.pd = 1;
                this.$router.push({path:'/myCoupon',query:{fromType: 'buy'}});
            },
          gotoinquiry(){
            this.$router.push({path:'/inquirypeople',query:{selectType: '1'}});
          },
          gotoxieyi(){
            this.$router.push({path:'/userAgreement'});
          },
          gotoChat(){
            let _this=this;
            let data={
              parameters: _this.docid,
              twoParameter: _this.$store.state.inquirypeople.id ?_this.$store.state.inquirypeople.id :_this.$store.state.userInfo.id,
            };
            this.$doRequest(
              "/api/AppHomePage/Index",data,
               res => {
                this.isNotBuy=res.isOrder;
                console.log(this.isNotBuy);
              })
          },
          gotoChatWith(){
            common.unLock(this,"todoctorLock"+this.docid);
            this.$router.push({path: '/physicianVisits?doctorID=' + this.docid});
          }
        },
        //生命周期之创建完成
        created: function() {

//          console.log(this.$store.state.inquirypeople);
            document.title = '购买在线复诊';
            this.docid = this.$store.state.AllOfValue.doctorId;
            this.sun =  this.$store.state.sun.price;
            if(this.$route.query.kfcSum != undefined){
                this.discount = this.$route.query.kfcSum;
            }else{
                this.discount = 0;
            }
            this.kfcid = this.$route.query.kfcId;
             this.getMyInquiry();
            this.$isLogin(window.location.search.substr(1), this.query);

        }
    }



// WEBPACK FOOTER //
// ./src/views/buyServiceDetails/index.vue